import { useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import GminaService from '@/services/GminaService'

export default function useGminaModal(loadData) {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [editingItem, setEditingItem] = useState(null)
	const [formName, setFormName] = useState('')
	const [formPowiatId, setFormPowiatId] = useState(null)
	const [formPowiatName, setFormPowiatName] = useState('')
	const [formWojewodztwoId, setFormWojewodztwoId] = useState(null)
	const [formWojewodztwoName, setFormWojewodztwoName] = useState('')
	const [isSaving, setIsSaving] = useState(false)
	const [isPowiatSelectOpen, setIsPowiatSelectOpen] = useState(false)
	const [isWojewodztwoSelectOpen, setIsWojewodztwoSelectOpen] = useState(false)

	const openCreateModal = () => {
		setEditingItem(null)
		setFormName('')
		setFormPowiatId(null)
		setFormPowiatName('')
		setFormWojewodztwoId(null)
		setFormWojewodztwoName('')
		setIsModalOpen(true)
	}

	const openEditModal = item => {
		setEditingItem(item)
		setFormName(item?.nazwa || '')

		const powiatValue = item?.id_powiat || item?.id_miasto?.id_powiat
		const powiatId =
			typeof powiatValue === 'object' ? powiatValue?._id || powiatValue?.id || null : powiatValue || null
		const powiatName = typeof powiatValue === 'object' ? powiatValue?.nazwa || '' : ''
		setFormPowiatId(powiatId)
		setFormPowiatName(powiatName)

		const wojewodztwoValue = item?.id_wojewodztwo || item?.id_powiat?.id_wojewodztwo || item?.id_miasto?.id_powiat?.id_wojewodztwo
		const wojewodztwoId =
			typeof wojewodztwoValue === 'object'
				? wojewodztwoValue?._id || wojewodztwoValue?.id || null
				: wojewodztwoValue || null
		const wojewodztwoName =
			typeof wojewodztwoValue === 'object' ? wojewodztwoValue?.nazwa || '' : ''
		setFormWojewodztwoId(wojewodztwoId)
		setFormWojewodztwoName(wojewodztwoName)
		setIsModalOpen(true)
	}

	const closeModal = () => {
		setIsModalOpen(false)
		setEditingItem(null)
		setFormName('')
		setFormPowiatId(null)
		setFormPowiatName('')
		setFormWojewodztwoId(null)
		setFormWojewodztwoName('')
		setIsPowiatSelectOpen(false)
		setIsWojewodztwoSelectOpen(false)
		setIsSaving(false)
	}

	const openPowiatSelectModal = () => {
		setIsPowiatSelectOpen(true)
	}

	const closePowiatSelectModal = () => {
		setIsPowiatSelectOpen(false)
	}

	const applyPowiatSelection = (powiatId, powiatName) => {
		setFormPowiatId(powiatId || null)
		setFormPowiatName(powiatName || '')
		setIsPowiatSelectOpen(false)
	}

	const openWojewodztwoSelectModal = () => {
		setIsWojewodztwoSelectOpen(true)
	}

	const closeWojewodztwoSelectModal = () => {
		setIsWojewodztwoSelectOpen(false)
	}

	const applyWojewodztwoSelection = (wojewodztwoId, wojewodztwoName) => {
		setFormWojewodztwoId(wojewodztwoId || null)
		setFormWojewodztwoName(wojewodztwoName || '')
		setIsWojewodztwoSelectOpen(false)
	}

	const handleSubmit = async e => {
		e.preventDefault()
		const name = formName.trim()
		if (!name || !formPowiatId || !formWojewodztwoId) return

		setIsSaving(true)
		const result = editingItem?._id
			? await GminaService.update(editingItem._id, {
					nazwa: name,
					id_powiat: formPowiatId,
					id_wojewodztwo: formWojewodztwoId,
				})
			: await GminaService.create({
					nazwa: name,
					id_powiat: formPowiatId,
					id_wojewodztwo: formWojewodztwoId,
				})

		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie zapisac gminy',
				icon: 'error',
			})
			setIsSaving(false)
			return
		}

		closeModal()
		await loadData()
	}

	const handleDelete = async item => {
		const confirm = await Swal.fire({
			title: 'Czy na pewno?',
			text: `Usunac gmine "${item?.nazwa || '-'}"?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Tak, usun',
			cancelButtonText: 'Anuluj',
		})
		if (!confirm.isConfirmed) return

		const result = await GminaService.delete(item?._id)
		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie usunac gminy',
				icon: 'error',
			})
			return
		}

		await loadData()
	}

	const buttons = useMemo(
		() => [
			{
				type: 'add',
				label: 'Dodaj nowe',
				onClick: openCreateModal,
			},
		],
		[]
	)

	return {
		isModalOpen,
		editingItem,
		formName,
		setFormName,
		formPowiatId,
		formPowiatName,
		formWojewodztwoId,
		formWojewodztwoName,
		isSaving,
		isPowiatSelectOpen,
		isWojewodztwoSelectOpen,
		openEditModal,
		handleDelete,
		closeModal,
		handleSubmit,
		openPowiatSelectModal,
		closePowiatSelectModal,
		applyPowiatSelection,
		openWojewodztwoSelectModal,
		closeWojewodztwoSelectModal,
		applyWojewodztwoSelection,
		buttons,
	}
}
